// @ts-strict-ignore
import { capitalize } from 'lodash-es'
import { useTranslation } from 'react-i18next'
import { Box, DataListItem } from '@node-space/ui-components'
import { ellipseMiddleText } from '@node-space/utils'
import { TAG_ENABLED_NETWORKS } from 'constants/General'
import { ContactInstrument } from 'types/contacts'

interface CryptoAddressSidePanelBodyProps {
  contactInstrument: ContactInstrument
}

export const CryptoAddressSidePanelBody = ({
  contactInstrument,
}: CryptoAddressSidePanelBodyProps) => {
  const { t } = useTranslation()

  const { address, tag, network, currency, selfHosted } = contactInstrument || {}

  const isStellar = network?.toLowerCase() === TAG_ENABLED_NETWORKS.STELLAR.toLowerCase()
  const tagLabel = isStellar ? t('formFields.memo') : t('formFields.destinationTag')

  return (
    <Box>
      <Box paddingT={8} paddingB={12}>
        {currency && (
          <DataListItem
            id="currency"
            testId="currency"
            title={t('formFields.currency')}
            body={currency.toUpperCase()}
          />
        )}
        {network && (
          <DataListItem
            id="network"
            testId="network"
            title={t('contacts.network')}
            body={capitalize(network)}
          />
        )}
        {address && (
          <DataListItem
            id="crypto-address"
            testId="crypto-address"
            title={t('formFields.walletAddress')}
            body={ellipseMiddleText(address, 12, 12)}
            copyText={address}
          />
        )}
        {tag && (
          <DataListItem
            id="destination-tag"
            testId="destination-tag"
            title={tagLabel}
            body={tag}
            copyText={tag}
          />
        )}
        <DataListItem
          id="self-hosted"
          testId="self-hosted"
          title={t('contacts.selfHosted')}
          body={selfHosted ? t('Yes') : t('No')}
        />
      </Box>
    </Box>
  )
}
